.cu{border:1px solid #ddd;}